export const RETRY_FETCH = 'personnelPage/RETRY_FETCH';

export const RELOAD = 'personnelPage/RELOAD';

export const CANCEL_INVITE = 'personnelPage/CANCEL_INVITE';
